var map = {
	"./AlienShooter.png": 21,
	"./Google.png": 22,
	"./Rahul.jpg": 8,
	"./amazon.jpeg": 23,
	"./covid.png": 24,
	"./header-background.jpg": 25,
	"./header-background2.jpg": 26,
	"./laait.png": 27,
	"./loader.gif": 9,
	"./news.png": 28,
	"./overlay-bg.png": 29,
	"./testimonials-bg.jpg": 30,
	"./youtube.jpg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;